/* Base */

.eds-checkbox {
  --eds--color--border-input-default: var(--eds--palette-gray-500);
  --eds--color--border-input-strong: var(--eds--palette-gray-700);
  cursor: pointer;
  display: inline-flex;
}

.eds-checkbox--labeled {
  cursor: default;
  display: flex;
  width: 100%;
}

.eds-checkbox--control {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: var(--eds--size-20);
  isolation: isolate;
  justify-content: center;
  padding: var(--eds--padding-2);
  position: relative;
  width: var(--eds--size-20);
}

.eds-checkbox--input {
  cursor: inherit;
  height: 100%;
  inset: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: var(--eds--z-index-2);
}

.eds-checkbox--label {
  align-self: flex-start;
  cursor: pointer;
}

.eds-checkbox--indicator {
  align-items: center;
  background: var(--eds--color--bg-base);
  border: var(--eds--size-1) solid var(--eds--color--border-input-default);
  border-radius: var(--eds--radii-4);
  box-sizing: border-box;
  color: var(--eds--color--fg-inverse);
  display: inline-flex;
  height: var(--eds--size-16);
  justify-content: center;
  position: relative;
  width: var(--eds--size-16);
  z-index: var(--eds--z-index-raised);
}

/* States */

.eds-checkbox--disabled {
  cursor: not-allowed;
  opacity: var(--eds--opacity-disabled);
}

.eds-checkbox--disabled .eds-checkbox--control,
.eds-checkbox--disabled .eds-checkbox--label {
  cursor: not-allowed;
}

.eds-checkbox--control::before {
  background-color: var(--eds--color--bg-base);
  background-image: linear-gradient(
    var(--eds--overlay-hover-default),
    var(--eds--overlay-hover-default)
  );
  border-radius: var(--eds--radii-8);
  content: '';
  height: var(--eds--size-24);
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--eds--size-24);
  z-index: var(--eds--z-index-base);
}

.eds-checkbox--control:has(.eds-checkbox--input:hover:not(:disabled)):not(
  :has(.eds-checkbox--input:focus-visible)
)::before {
  opacity: 1;
}

.eds-checkbox--input:hover:not(:disabled) + .eds-checkbox--indicator {
  border-color: var(--eds--color--border-input-strong);
}

.eds-checkbox--control::after {
  background: var(--eds--color--bg-base);
  border: var(--eds--size-2) solid var(--eds--color--border-brand);
  border-radius: var(--eds--radii-8);
  box-sizing: border-box;
  content: '';
  height: var(--eds--size-24);
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--eds--size-24);
  z-index: var(--eds--z-index-base);
}

.eds-checkbox--control:has(
  .eds-checkbox--input:focus-visible:not(:disabled)
)::after {
  border-color: var(--eds--color--border-brand);
  opacity: 1;
}

.eds-checkbox--control-critical:not(
  :has(.eds-checkbox--input:focus-visible:not(:disabled))
)::after {
  border-color: var(--eds--color--border-critical);
  opacity: 1;
}

.eds-checkbox--control-cautious:not(
  :has(.eds-checkbox--input:focus-visible:not(:disabled))
)::after {
  border-color: var(--eds--color--border-cautious);
  opacity: 1;
}

.eds-checkbox--indicator-critical {
  background: var(--eds--color--bg-critical-soft);
}

.eds-checkbox--indicator-cautious {
  background: var(--eds--color--bg-cautious-soft);
}

.eds-checkbox--indicator-selected,
.eds-checkbox--indicator-indeterminate {
  background: var(--eds--color--bg-brand-strong);
  border-color: var(--eds--color--bg-brand-strong);
}
